import React from 'react';
import { Radio, Row, Col, Button } from 'antd';
import { rgbToHex2 } from '../../../helpers/helpers';
// import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Crop, Upload, ZoomIn, ZoomOut } from 'react-feather'


const MainCanvas = (props) => {
    const getEventLocation = (element, event) => {
        const pos = getElementPosition(element);
        return {
            x: (event.pageX - pos.x),
            y: (event.pageY - pos.y)
        };
    }

    const getElementPosition = (obj) => {
        var curleft = 0, curtop = 0;
        if (obj.offsetParent) {
            do {
                curleft += obj.offsetLeft;
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);
            return { x: curleft, y: curtop };
        }
        return undefined;
    }


    const copyColor = (e) => {
        const canvas = document.getElementById("canvas");
        const eventLocation = getEventLocation(canvas, e);

        // Get the data of the pixel according to the location generate by the getEventLocation function
        const context = canvas.getContext('2d');
        const pixelData = context.getImageData(eventLocation.x, eventLocation.y, 1, 1).data
        const hex = ("000000" + rgbToHex2(pixelData[0], pixelData[1], pixelData[2])).slice(-6);
        props.setClickedColor(hex)
        const colorButton = document.getElementById("addColor");
        colorButton.click();
    }

    const handleMouseMove = (e) => {
        const canvas = document.getElementById("canvas");
        const canvasScroll = document.getElementById("canvasScroll");
        const eventLocation = getEventLocation(canvas, e);

        // Get the data of the pixel according to the location generate by the getEventLocation function
        const context = canvas.getContext('2d');
        // console.log(eventLocation.x, eventLocation.y, canvasScroll.scrollTop, canvasScroll.scrollLeft)
        const pixelData = context.getImageData(eventLocation.x + canvasScroll.scrollLeft, eventLocation.y + canvasScroll.scrollTop, 1, 1).data;
        const hex = "#" + ("000000" + rgbToHex2(pixelData[0], pixelData[1], pixelData[2])).slice(-6);

        // Draw the color and coordinates.
        document.getElementById("status").innerHTML = hex;
        document.getElementById("color").style.backgroundColor = hex;
    }

    return (
<div style={{height:"calc(100% - 40px)", cursor:`url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path stroke-width="1" style="stroke: white; fill: black;" d="M17.542 13.147l-7.455-6.667 1.334-1.49c.822.736 2.087.666 2.822-.159l3.503-3.831c.593-.663 1.414-1 2.238-1 1.666 0 3.016 1.358 3.016 2.996 0 .723-.271 1.435-.78 2.005l-3.503 3.83c-.735.824-.666 2.087.158 2.825l-1.333 1.491zm-4.314-1.175l-7.791 8.65c-.314.352-1.322.323-1.853.557.172-.554.048-1.538.362-1.89l7.791-8.651-1.491-1.333-7.9 8.794c-1.277 1.423-.171 2.261-1.149 4.052-.135.244-.197.48-.197.698 0 .661.54 1.151 1.141 1.151.241 0 .492-.079.724-.256 1.733-1.332 2.644-.184 3.954-1.647l7.9-8.792-1.491-1.333z"/></svg>') 0 24, auto`}} >
  <div id='canvasScroll' style={{ overflow: 'auto', backgroundColor: '#f0f0f0', height:'100%'}}>
    <center>
      <canvas id="canvas" width="10" height="10" onClick={copyColor} onMouseMove={(e) => { handleMouseMove(e) }} ></canvas>
      {/* style={{ cursor:`url('data:image/svg+xml;utf8,<svg id="svg" xmlns="http://www.w3.org/2000/svg" version="1.1" width="32" height="32"><circle cx="10" cy="10" r="10" stroke-width="1" style="stroke: black; fill: %23FFFFFF;"/></svg>'), auto`}} */}
    </center>
  </div>
</div>
    );
};

export default MainCanvas;